<template>
	<div class="app-main">
		<div style="padding-bottom: 5px;display: flex;align-items: center;">
			<el-divider direction="vertical"></el-divider>
			<span>企业信息</span>
		</div>
		<div style="padding-bottom: 5px;">
			<el-alert description="适用于企业、个体商户、事业单位等、通过营业执照、组织机构代码等">
			</el-alert>
		</div>
		<el-form label-width="140px" ref="form" :model="form" :disabled="preview" :rules="rules" size="small">
			<el-row>
				<el-col :span="12">
					<el-form-item label="统一社会信息代码" prop="tyShXxCode">
						<el-input v-model="form.tyShXxCode" placeholder="请输入统一社会信息代码" />
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="企业名称" prop="name">
						<el-input v-model="form.name" placeholder="请输入企业名称" />
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="英文名称">
						<el-input v-model="form.englishName" placeholder="请输入英文名称" />
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="企业简称" prop="qyShort">
						<el-input v-model="form.qyShort" placeholder="请输入企业简称" />
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="组织机构代码" prop="orgJgCode">
						<el-input v-model="form.orgJgCode" placeholder="请输入组织机构代码" />
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="认证地区" prop="rzRegion">
						<el-select v-model="form.rzRegion" placeholder="请选择认证地区" style="width: 100%">
							<el-option label="境内机构" value="境内机构"></el-option>
							<el-option label="境外机构" value="境外机构"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="企业类型" prop="qyTyoe">
						<el-select v-model="form.qyTyoe" placeholder="请选择企业类型" style="width: 100%;">
							<el-option v-for="item in qyTyoes" :key="item.name" :label="item.name" :value="item.name">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="纳税人标识" prop="taxpayerSign">
						<el-select v-model="form.taxpayerSign" placeholder="请选择纳税人标识" style="width: 100%;">
							<el-option label="一般纳税人" value="一般纳税人">
							</el-option>
							<el-option label="小规模纳税人" value="小规模纳税人">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="注册国家/地区" prop="country">
						<el-select v-model="form.country" placeholder="请选择" style="width: 100%;" filterable>
							<el-option v-for="item in countrys" :key="item.name" :label="item.name" :value="item.name">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>

				<el-col :span="12">
					<el-form-item label="法定代表人" prop="legalPerson">
						<el-input v-model="form.legalPerson" placeholder="请输入法定代表人" />
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="注册资本(万)" prop="zcCapital">
						<el-input v-model.number="form.zcCapital" placeholder="请输入注册资本" />
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="注册资本货币种类" prop="zcCurrency">
						<el-select v-model="form.zcCurrency" placeholder="请选择" style="width: 100%;" filterable>
							<el-option v-for="item in zcCurrencys" :key="item.id" :label="item.name" :value="item.code">
								<span style="float: left">{{ item.name }}</span>
								<span style="float: right; color: #8492a6; font-size: 13px">{{ item.shCountry }}</span>
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="建立日期" prop="foundDate">
						<el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="form.foundDate"></el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="营业执照图附件" prop="yyZzSrc">
						<el-upload class="upload-demo" :action="upload()" :show-file-list="false" accept="image/*,.pdf,.doc,.docx,.xlsx"
							:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
							:headers="{'Authentication':token()}">
							<el-input v-model="form.yyZzSrc" placeholder="点击文本框上传" readonly slot="trigger" />
						</el-upload>
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item label="详细地址" prop="address">
						<el-input v-model="form.address" type="textarea" :rows="1" placeholder="请输入详细地址" />
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item label="经营范围" prop="manageArea">
						<el-input v-model="form.manageArea" type="textarea" placeholder="请输入经营范围" />
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div v-if="!preview" style="text-align: center;">
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForm(1)" size="small">下一步</el-button>
			</span>
		</div>
	</div>
</template>

<script>
	import {
		supplierInfoById,
		addSupplierInfo,
		editSupplierInfo,
		supplierInfoFindName,
		addSupplierApprovalMx,
		getSupplierApprovalMx,
	} from '@/api/gys/supplierInfo.js'
	import {
		basicCurrencyListAll
	} from '@/api/basic/basicCurrency.js'
	import constant from '@/api/commons.js'

	export default {
		name: "RegisterInfo",
		computed: {},
		props: {
			basicId: {
				type: Number,
			},
			preview: {
				type: Boolean,
				default: false
			},
			otherInfo: {
				type: Object,
				default: {}
			}
		},
		data() {
			return {
				title: "",
				tableData: [],
				qyTyoes: constant.qyTyoes,
				countrys: constant.country,
				form: {
					id: undefined,
					// createTime: undefined,
					// createUser: this.$store.getters['user/user'].id,
					name: undefined,
					rzRegion: undefined,
					tyShXxCode: undefined,
					englishName: undefined,
					qyShort: undefined,
					orgJgCode: undefined,
					qyTyoe: undefined,
					taxpayerSign: undefined,
					country: undefined,
					address: undefined,
					legalPerson: undefined,
					zcCapital: undefined,
					zcCurrency: 'CNY',
					foundDate: undefined,
					manageArea: undefined,
					yyZzSrc: undefined,
				},
				loadingInstance: undefined,
				count: 0,
				fileName: '',
				quertInfo: {
					page: 1, //当前页码
					limit: 20, //当前每页显示的数量
					searchTime: [],
					objMap: {
						search: ''
					}
				},
				zcCurrencys: [],
				rules: {
					name: [{
						required: true,
						message: '请输入企业名称',
						trigger: 'blur'
					}],
					rzRegion: [{
						required: true,
						message: '请选择认证地区',
						trigger: 'blur'
					}],
					tyShXxCode: [{
						required: true,
						message: '请输入统一社会信息代码',
						trigger: 'blur'
					}],

					qyTyoe: [{
						required: true,
						message: '请输入企业类型',
						trigger: 'blur'
					}],
					taxpayerSign: [{
						required: true,
						message: '请输入纳税人标识',
						trigger: 'blur'
					}],
					country: [{
						required: true,
						message: '请输入注册国家/地区',
						trigger: 'blur'
					}],
					address: [{
						required: true,
						message: '请输入详细地址',
						trigger: 'blur'
					}],
					legalPerson: [{
						required: true,
						message: '请输入法定代表人',
						trigger: 'blur'
					}],
					zcCapital: [{
						required: true,
						type: 'number',
						message: '请输入注册资本(万)',
						trigger: 'blur'
					}],
					zcCurrency: [{
						required: true,
						message: '请输入注册资本货币种类',
						trigger: 'blur'
					}],
					foundDate: [{
						required: true,
						message: '请输入建立日期',
						trigger: 'blur'
					}],
					manageArea: [{
						required: true,
						message: '请输入经营范围',
						trigger: 'blur'
					}],
					yyZzSrc: [{
						required: false,
						message: '请上传营业执照图附件',
						trigger: 'blur'
					}]

				}
			};
		},
		mounted() {
			this.getBasicCurrencyListAll();
			// this.getList()
			this.getInfo()
		},
		methods: {
			getBasicCurrencyListAll: function() {
				let _this = this;
				basicCurrencyListAll().then(response => {
					if (response.data.code === 0) {
						_this.zcCurrencys = response.data.data;
					}
				});
			},
			async getList() {
				let _this = this;
				const { data: res } = await supplierInfoById({ id: _this.basicId })
				if (res.code == 0) {
					// _this.form = res.data;
					_this.form = {
						id: res.data.id,
						// createTime: undefined,
						// createUser: this.$store.getters['user/user'].id,
						// name: res.data.name,
						// rzRegion: res.data.rzRegion,
						// tyShXxCode: res.data.tyShXxCode,
						// englishName: res.data.englishName,
						// qyShort: res.data.qyShort,
						// orgJgCode: res.data.orgJgCode,
						// qyTyoe: res.data.qyTyoe,
						// taxpayerSign: res.data.taxpayerSign,
						// country: res.data.country,
						// address: res.data.address,
						// legalPerson: res.data.legalPerson,
						// zcCapital: res.data.zcCapital,
						// zcCurrency: res.data.zcCurrency,
						// foundDate: res.data.foundDate,
						// manageArea: res.data.manageArea,
						// yyZzSrc: res.data.yyZzSrc,
					};
					// _this.$emit("basicIdFun", res.data.id);

				}
			},
			// 获取信息回填
			getInfo(){
				let pramar = {
					classType:'com.srm.entity.SupplierInfo',
					classTypeIndex:'0',
					supplierInfoId:this.basicId,
				};
				if(this.otherInfo.lastPass){
					pramar['queryType']='lastPass'
				}
				getSupplierApprovalMx(pramar).then(({data:res})=>{
					if(res.data && res.data.jsonData){
						let JsonInfo = JSON.parse(res.data.jsonData);
						this.form = {
							id: JsonInfo.id,
							name: JsonInfo.name,
							rzRegion: JsonInfo.rzRegion,
							tyShXxCode: JsonInfo.tyShXxCode,
							englishName: JsonInfo.englishName,
							qyShort: JsonInfo.qyShort,
							orgJgCode: JsonInfo.orgJgCode,
							qyTyoe: JsonInfo.qyTyoe,
							taxpayerSign: JsonInfo.taxpayerSign,
							country: JsonInfo.country,
							address: JsonInfo.address,
							legalPerson: JsonInfo.legalPerson,
							zcCapital: JsonInfo.zcCapital,
							zcCurrency: JsonInfo.zcCurrency,
							foundDate: JsonInfo.foundDate,
							manageArea: JsonInfo.manageArea,
							yyZzSrc: JsonInfo.yyZzSrc,
						}
					}
				})
			},
			// 表单重置
			reset: function() {
				this.form = {
					id: undefined,
					createTime: undefined,
					createUser: this.$store.getters['user/user'].id,
					name: undefined,
					rzRegion: undefined,
					tyShXxCode: undefined,
					englishName: undefined,
					qyShort: undefined,
					orgJgCode: undefined,
					qyTyoe: undefined,
					taxpayerSign: undefined,
					country: 'CNY',
					address: undefined,
					legalPerson: undefined,
					zcCapital: undefined,
					zcCurrency: undefined,
					foundDate: undefined,
					manageArea: undefined,
					yyZzSrc: undefined,
				}
				if (this.$refs["form"] !== undefined) {
					this.$refs["form"].resetFields();
				}
			},
			submitForm(stemp) {
				let _this = this;
				_this.$refs['form'].validate((valid) => {
					if (valid) {
						let formObj = {..._this.form};
						delete formObj.id
						addSupplierApprovalMx({
							classType:'com.srm.entity.SupplierInfo',
							classTypeIndex:'0',
							supplierInfoId:_this.basicId,
							jsonData:JSON.stringify(formObj)
						}).then(response => {
							if (response.data.code === 0) {
								_this.bus.$emit('stepsFun', stemp);
							} else {
								_this.$fail(response.data.msg);
							}
						});
						// com.srm.entity.SupplierInfo

						// if (_this.form.id != undefined) {
						// 	editSupplierInfo(_this.form).then(response => {
						// 		if (response.data.code === 0) {
						// 			_this.bus.$emit('stepsFun', 1);
						// 		} else {
						// 			_this.$fail(response.data.msg);
						// 		}
						// 	});
						// } else {
						// 	supplierInfoFindName({
						// 		name: _this.form.name
						// 	}).then(res => {
						// 		if (res.data.code === 0) {
						// 			addSupplierInfo(_this.form).then(response => {
						// 				if (response.data.code === 0) {
						// 					_this.getList();
						// 					// _this.$emit("basicIdFun", response.data.data);
						// 					_this.bus.$emit('stepsFun', 1);
						// 				} else {
						// 					_this.$fail('保存失败');
						// 				}
						// 			});
						// 		}
						// 		// else {
						// 		// 	_this.$fail(res.data.msg);
						// 		// }
						// 	});
						// }
					}
				});
			},
			//下一步
			nextStep: function() {
				this.bus.$emit('stepsFun', 1);
			},
			handleAvatarSuccess(res, file) {
				if (res.code == 0) {
					this.$success(res.msg);
					if (this.form.yyZzSrc != "" && this.form.yyZzSrc != undefined) {
						//如果修改附件 则删除原来的附件
						if (this.form.yyZzSrc != res.data.url) {
							this.delFile(this.form.yyZzSrc);
						}
					}
					this.form.yyZzSrc = res.data.url;
				}
			},
			beforeAvatarUpload(file) {
				let type = file.name.substring(file.name.lastIndexOf('.') + 1) //判断文件后缀
				const isLt2M = file.size / 1024 / 1024 < 4;
				if (!isLt2M) {
					this.$fail('上传附件大小不能超过 4MB!');
					return false
				}
				if (type == 'png' || type == 'jpg' || type == 'jpeg'){

				}else{
					return false;
				}

			},

		}
	};
</script>
<style scoped="scoped">

</style>
